export const PRIMARY = '#1F3C45';           // Green
export const PRIMARY_LIGHT = '#1f3c451c';   // Green light  
export const SECONDARY = '#FAA412';         // ORANGE

